import { FC } from "react";

import { MenuItem } from "services/app/types";

interface FooterItemProps {
  menuItem: MenuItem;
}

const SiteMapColumnItem: FC<FooterItemProps> = ({ menuItem }) => (
  <>
    <a href={(menuItem.domain || "") + menuItem.path} className="text -footer">
      {menuItem.name}
    </a>
    <div className="-sub-links">
      {menuItem.children &&
        menuItem.children.map((item: MenuItem, index: number) => (
          <SiteMapColumnItem menuItem={item} key={`${index}-${item.name}`} />
        ))}
    </div>
  </>
);

export default SiteMapColumnItem;
